import React from "react";
import styles from "./newsModule.module.css";
import { HashLink as Link } from "react-router-hash-link";
import { getDate, convertToPlain } from "../util/auth.js";

class NewsModule extends React.Component {

    createMarkup(news) {
        return { __html: news.description };
    }

  render() {
    return (
      <div
        className={styles.moduleContainer}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className={styles.linkContainer}>
          <Link className={styles.anchor} to="/news#1">
            <div className={styles.newsContainer}>
              <div className={styles.date}>
                            {getDate(this.props.content.newsAPI[0].pubDate)}
              </div>
              <div className={styles.header}>
                {this.props.content.newsAPI[0].title}
              </div>
                <div className={styles.content}>
                    {convertToPlain(this.props.content.newsAPI[0].description)}
                </div>
                <div className={styles.next}>
                    подробнее...
            </div>
            </div>
          </Link>
        </div>
        <div className={styles.linkContainer}>
          <Link className={styles.anchor} to="/news#2">
            <div className={styles.newsContainer}>
              <div className={styles.date}>
                            {getDate(this.props.content.newsAPI[1].pubDate)}
              </div>
              <div className={styles.header}>
                {this.props.content.newsAPI[1].title}
              </div>
                        <div className={styles.content}>
                            {convertToPlain(this.props.content.newsAPI[1].description)}
                        </div>
                        <div className={styles.next}>
                            подробнее...
            </div>
            </div>
          </Link>
        </div>
        <div className={styles.linkContainer}>
          <Link className={styles.anchor} to="/news#3">
            <div className={styles.newsContainer}>
              <div className={styles.date}>
                            {getDate(this.props.content.newsAPI[2].pubDate)}
              </div>
              <div className={styles.header}>
                {this.props.content.newsAPI[2].title}
              </div>
                        <div className={styles.content}>
                            {convertToPlain(this.props.content.newsAPI[2].description)}
                        </div>
                        <div className={styles.next}>
                            подробнее...
            </div>
            </div>
          </Link>
        </div>
        <div className={styles.archiveContainer}>
          <Link className={styles.anchor} to="/news#1">
            <div style={{ paddingTop: "5%", paddingLeft: "20%" }}>
              Архив новостей
            </div>
          </Link>
        </div>
      </div>
    );
  }
}

export default NewsModule;
